import {
  getJobs,
  getSecteurs,
  getSousSecteurs,
  getResidents,
  getPersonnels,
  getLieux,
  getActivites,
  linkGetLieux,
  linkGetSecteurs,
  linkGetSousSecteurs,
  linkGetResidents,
  linkGetPersonnels
} from '../netsoins'

import {
  checkUrl,
  getDomain
} from '../misc/urlnetsoins'

function checkParam(param){
  return (param.uri?.length > 0 && param.key?.length > 0 && checkUrl(param.uri))
}

function normalizeParam(param){
  param.uri = getDomain(param.uri);
  return param; 
}

function OrderByFullName(a, b){

    const nameA = `${a.Nom} ${a.prenom}`.toUpperCase(); // ignore upper and lowercase
    const nameB = `${b.Nom} ${b.prenom}`.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
  
    // names must be equal
    return 0;
}


export async function Jobs(param){
  if (checkParam(param))
    return await getJobs(normalizeParam(param));
}

export async function Secteurs(param){
  if (checkParam(param))
    return await getSecteurs(normalizeParam(param));
}

export async function SousSecteurs(param){
  if (checkParam(param))
    return await getSousSecteurs(normalizeParam(param));
}

export async function Residents(param){
  if (checkParam(param)) {
    const data = await getResidents(normalizeParam(param));

    return data?.sort(OrderByFullName) ?? data;
  }
}

export async function Personnels(param){
  if (checkParam(param)){
    const data = await  getPersonnels(normalizeParam(param));
    return data?.sort(OrderByFullName) ?? data;
  }
}

export async function Lieux(param){
  if (checkParam(param)){
    const data = await  getLieux(normalizeParam(param));
    if (data) return data.filter((l) => l.Activite === "1");
    return data;
  }
}

export async function Activites(param){
  if (checkParam(param)){
    return await getActivites(normalizeParam(param));
  }
}

export function Links(type, param){
  if (type === "lieux") return linkGetLieux(normalizeParam(param));
  if (type === "secteurs") return linkGetSecteurs(normalizeParam(param));
  if (type === "soussecteurs") return linkGetSousSecteurs(normalizeParam(param));
  if (type === "residents") return linkGetResidents(normalizeParam(param));
  if (type === "personnels") return linkGetPersonnels(normalizeParam(param));

  return null;
}